import clsx from 'clsx';
import React from 'react';
import { useHistory } from 'react-router';
import { withStyles } from '@material-ui/core';

import {
  getErrorMessage,
  isConnectionError,
  getHttpErrorStatus,
  getErrorDescription,
  isHttpForbiddenResponse,
} from '../../utils/requests';

import styles from './style';
import Box from '../atomic/Box';
import Button from '../atomic/Button';
import Typography from '../atomic/Typography';
import useDesktop from '../../hooks/useDesktop';
import Logo from '../../assets/icons/BoligmappaLogo';
import { GENERIC_CLIENT_ERROR_CODE } from '../../constants';
import ConnectionError from '../../assets/icons/ConnectionError';

export const ErrorContainer = ({
  user,
  classes,
  children,
  className,
  errorCode,
  errorResponse,
  customErrorObject,
  paddings = true,
  paddingTop = true,
  onHomeRedirect = () => {},
  ...props
}) => {
  const history = useHistory();
  const isDesktop = useDesktop();

  const isRuntimeError =
    !errorResponse && errorCode === GENERIC_CLIENT_ERROR_CODE;

  const actionButtonText = isRuntimeError
    ? 'Gå til hjemskjerm'
    : 'Prøv på nytt';

  const onRefreshClick = () => {
    if (isRuntimeError) {
      onHomeRedirect();
      history.push('/');
    } else {
      window.location.reload();
    }
  };

  const errorMessage = getErrorMessage(errorResponse, children);

  const errorDescription = getErrorDescription(errorResponse);

  if (
    customErrorObject &&
    isHttpForbiddenResponse(getHttpErrorStatus(errorResponse))
  ) {
    return (
      <div
        className={clsx(
          classes.container,
          paddings && classes.containerPaddings,
          paddingTop && classes.customMessagePaddingTop,
          className
        )}
        {...props}
      >
        <Logo className={classes.logo} />

        <Box textAlign="center">
          <Typography
            variant="h2"
            color="textPrimary"
            className={classes.alignCenter}
          >
            {children || <>{customErrorObject.title}</>}
          </Typography>

          {customErrorObject.message && (
            <Typography
              variant="body2"
              color="textPrimary"
              className={classes.helpText}
            >
              {customErrorObject.message}
            </Typography>
          )}
        </Box>
      </div>
    );
  }

  return (
    <Box
      className={clsx(
        classes.container,
        paddings && classes.containerPaddings,
        paddingTop && classes.containerPaddingTop,
        className
      )}
      {...props}
    >
      {isConnectionError(errorResponse) ? (
        <ConnectionError className={classes.connectionErrorIcon} />
      ) : (
        <Logo className={classes.logo} />
      )}

      <Box textAlign="center">
        <Typography
          variant="h2"
          color="primary"
          className={classes.textContainer}
        >
          {errorMessage}
        </Typography>

        <Box mt={4}>
          <Typography
            variant="body2"
            color="textPrimary"
            className={classes.helpText}
          >
            {errorDescription}
          </Typography>
        </Box>
      </Box>

      <Box mt={4}>
        <Button
          rounded
          size="large"
          color="secondary"
          variant="contained"
          fullWidth={isDesktop}
          onClick={onRefreshClick}
        >
          {actionButtonText}
        </Button>

        <Box mt={2}>
          <Button
            rounded
            size="large"
            color="primary"
            variant="outlined"
            fullWidth={isDesktop}
            onClick={() => history.push('/dashboard/overview')}
          >
            Gå til forsiden
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default withStyles(styles)(ErrorContainer);
